<template>
  <div class="customer-box" v-if="visible">
<!--    <img-->
<!--      :src="require('@/static/user/close.png')"-->
<!--      alt="关闭"-->
<!--      class="close-img"-->
<!--      @click="handleClose"-->
<!--    />-->
    <img
      @mouseenter="handleMouseEnter"
      @mouseleave="handleMouseLeave"
      :src="require('@/static/user/customer.png')"
      alt="客服图片"
      class="customer-img"
    />
    <img class="wechat-image" :src="configInfo.wechat_qrcode">
    <div class="word">随时查收 <br> 最新报价</div>
    <div
      class="kefu"
      v-if="showLine"
      @mouseenter="handleMouseEnter"
      @mouseleave="handleMouseLeave"
    >
      <div class="kefu-top">
        <div class="kefu-title">您的专属业务</div>
        <el-button type="text" @click="handleCopyQrcode">点击复制微信号码</el-button>
        <div class="kefu-top-img">
          <img :src="customerInfo.qrcode" alt="" />
        </div>
        <span class="desc">微信扫一扫立即添加</span>
      </div>
      <div class="line">联系电话 {{ customerInfo.mobile ||'--'}}</div>
    </div>
  </div>
</template>
<script>
import { getMyCustomerService } from "@/api/modules/user";
export default {
  name: "customer",
  data() {
    return {
      visible: true,
      showLine: false,
      customerInfo: {},
      isMouseInKefu: false,
    };
  },
  computed: {
    configInfo() {
      return this.$store.state.config.config;
    },
  },
  created() {
    this.getMyCustomer();
  },
  methods: {
    handleCopyQrcode() {
      if (this.customerInfo.wechat) {
        this.$utils.copyText(this.customerInfo.wechat, this);
      } else {
        this.$message.warning({
          message: "微信号码不存在",
          duration: 2000,
          offset: 200,
        });
      }
    },
    getMyCustomer() {
      getMyCustomerService().then((res) => {
        if (res.data.code == 10000) {
          this.customerInfo = res.data.data.yewu;
        }
      });
    },
    handleClose() {
      this.visible = false;
    },
    handleMouseEnter() {
      this.showLine = true;
      this.isMouseInKefu = true;
    },
    handleMouseLeave() {
      this.isMouseInKefu = false;
      setTimeout(() => {
        if (!this.isMouseInKefu) {
          this.showLine = false;
        }
      }, 100);
    },
  },
};
</script>
<style lang="scss" scoped>
.word{
  font-size: 12px;
  color: #606266;
  text-align: center;
   letter-spacing: 4px;
}
.wechat-image{
  width: 85px;
  height: 85px;
}
.customer-box {
  width: 100px;
  height: 94px;
  position: fixed;
  top: 60vh;
  right: 5px;
  bottom: 20px;
  z-index: 1000009999;
  .close-img {
    width: 16px;
    height: 16px;
    position: absolute;
    right: 0;
  }
  .customer-img {
    width:100px;
    height: 120px;
    object-fit: contain;
  }
  .kefu {
    position: absolute;
    left: -240px;
    top: -190px;
    width: 240px;
    //height: 288px;
    background: #f8faff;
    border: 1px #4393FE solid;
    border-radius: 14px;
    overflow: hidden;
    .line {
      background: #ececec;
      height: 48px;
      width: 100%;
      text-align: center;
      line-height: 48px;
      font-weight: 400;
      font-size: 16px;
      color: #00112b;
    }
    .kefu-top {
      padding: 20px 50px;
      text-align: center;
      .kefu-title {
        font-weight: 600;
        font-size: 18px;
        color: #00112b;
      }
      .kefu-top-img {
        width: 135px;
        height: 136px;
        margin: 12px 0;
        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
      .desc {
        font-weight: 300;
        font-size: 12px;
        color: #afafaf;
      }
    }
  }
}
</style>
